import React, { useState, useEffect } from 'react';
import { Button, Table, Container, Alert, Collapse, Spinner, Modal, Form, Row, Col } from 'react-bootstrap';
import api from '../../../redux/actions/configApi'; // Assumindo que a API está configurada nesse arquivo
import Loader from '../../../components/loading';
import PaginationComponent from '../../../components/paginacao';
import '../../../style/proposta.css';
import { formatPriceBR, formatDateBR } from '../../../util';
import { useDispatch, useSelector } from 'react-redux';
//import { fetchUserProposals, updateBankData } from '../../../redux/reducers/propostaUserSlice';
import { fetchUserProposals, updateBankData, setCurrentPage, clearMessages } from '../../../redux/reducers/propostaUserSlice';

const Proposta = () => {
    const [success, setSuccess] = useState(false);
    const dispatch = useDispatch();
    //   const [error, setError] = useState(false);
    // const [loading, setLoading] = useState(false);
    // const [proposals, setProposals] = useState([]);
    const [selectedProposal, setSelectedProposal] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showModalStatus, setShowModalStatus] = useState(false);
    const [status, setStatus] = useState(''); // Novo estado para o status
    const [sendCode, setSendCode] = useState(''); // Código de envio
    const [rejectionReason, setRejectionReason] = useState(''); // Motivo da reprovação
    const [showEditModal, setShowEditModal] = useState(false);
    //Variaveis selecinadas
    const [conexao, setConexao] = useState(null)
    const [cor, setCor] = useState(null)
    const [operacao, setOperacao] = useState(null)
    const [capacidade, setCapacidade] = useState(null)
    const [acessorios, setAcessorios] = useState([])
    const [defeitos, setDefeitos] = useState([])
    const [pagination, setPagination] = useState({
        currentPage: 1,
        lastPage: 1,
    });
    const { proposals, loading, error, successMessage, currentPage, totalItems, itemsPerPage } = useSelector(
        (state) => state.propostaUserSlice
    );
    // Função para buscar as propostas da API
    /*  const fetchProposals = async (page = 1) => {
          try {
              setLoading(true);
              const response = await api.get(`proposals-user?page=${page}`);
              const { data, current_page, last_page } = response.data;
  
              // Salva as propostas e as informações de paginação no estado
              setProposals(data);
              setPagination({
                  currentPage: current_page,
                  lastPage: last_page,
              });
              setLoading(false);
          } catch (error) {
              setError('Erro ao carregar as propostas.');
              setLoading(false);
          }
      };*/

    // UseEffect para buscar as propostas ao montar o componente
    /*useEffect(() => {
        fetchProposals();
    }, []);*/

    useEffect(() => {
        dispatch(fetchUserProposals({ page: currentPage }));
    }, [dispatch, currentPage]);

    const handlePageChange = (page) => {
        dispatch(setCurrentPage(page));
        dispatch(fetchUserProposals({ page }));
    };

    // Limpar mensagens de sucesso/erro após 3 segundos (opcional)
    useEffect(() => {
        if (successMessage || error) {
            const timer = setTimeout(() => {
                dispatch(clearMessages());
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [successMessage, error, dispatch]);

    /* const handlePageChange = (page) => {
         fetchProposals(page);
     };*/

    // Função para exibir detalhes da proposta selecionada
    const handleViewDetails = (proposal) => {
        setSelectedProposal(proposal);
        setShowModal(true); // Abre o modal
    };

    const handleEdit = (proposal) => {
        console.log(proposal, 'proposal')
        setSelectedProposal(proposal);
        setShowEditModal(true);
    }

    const handleBankDetailChange = (event) => {
        const { name, value } = event.target;
        setSelectedProposal((prevProposal) => ({
            ...prevProposal,
            bank_data: {
                ...prevProposal.bank_data,
                [name]: value,
            },
        }));
    }

    const handleModalClose = () => {
        setShowEditModal(false);
        setSelectedProposal(null);
    };

    /* const handleCloseModal = () => {
         setSelectedProposal(null);
         setShowModal(false); // Fecha o modal
     };*/

    /*  const handleStatusChange = (proposal) => {
          setSelectedProposal(proposal);
          setShowModalStatus(true);
      };*/

    const getTextoTabela = (statusValue) => {
        switch (Number(statusValue)) {
            case 4:
                return 'Código de envio enviado';
            case 5:
                return 'Em trânsito';
            case 6:
                return 'Venda aprovada';
            case 7:
                return 'Venda reprovada';
            case 8:
                return 'Contraproposta enviada';
            case 9:
                return 'Contraproposta aprovada';
            case 10:
                return 'Produto devolvido';
            case 11:
                return 'Venda cancelada';
            default:
                return 'Aguardando';
        }
    };

    useEffect(() => {
        if (selectedProposal && typeof selectedProposal?.bank_data === "string") {
            try {
                const parsedBankData = JSON.parse(selectedProposal?.bank_data);
                setSelectedProposal((prev) => ({
                    ...prev,
                    bank_data: parsedBankData,
                }));
            } catch (error) {
                console.error("Erro ao analisar os dados bancários:", error);
            }
        }
    }, [selectedProposal]);

    useEffect(() => {
        //console.log(selectedOptionsArray, 'selectedOptionsArray');
        let conexaoEncontrada = false;
        let corEncontrada = false;
        let capacidadeEncontrada = false;
        let acessoriosEncontrados = false;
        let defeitosEncontrados = false;
        let operacaoEncontrada = false;
        console.log(selectedProposal, 'selectedProposal')
        // Itera sobre o array principal
        selectedProposal?.selected_options?.forEach((option) => {
            if (option.atributo === "Conexão" && Array.isArray(option.items)) {
                conexaoEncontrada = true;
                // Atualiza o estado com o valor encontrado
                setConexao(option.items[0]?.value || null); // Primeiro valor ou null
            }
            if (option.atributo === "Capacidade" && Array.isArray(option.items)) {
                capacidadeEncontrada = true;
                setCapacidade(option.items[0]?.value || null);
            }
            if (option.atributo === "Cores" && Array.isArray(option.items)) {
                corEncontrada = true;
                setCor(option.items[0]?.value || null);
            }
            if (option.atributo === "Acessórios" && Array.isArray(option.items)) {
                acessoriosEncontrados = true;
                setAcessorios(option.items);
            }
            if (option.atributo === "Defeitos" && Array.isArray(option.items)) {
                defeitosEncontrados = true;
                setDefeitos(option.items);
            }
            if (option.atributo === "Operação" && Array.isArray(option.items)) {
                operacaoEncontrada = true;
                setOperacao(option.items[0]?.value || null);
            }
        });

        // Redefine o estado se o atributo não foi encontrado
        if (!conexaoEncontrada) setConexao(null);
        if (!capacidadeEncontrada) setCapacidade(null);
        if (!acessoriosEncontrados) setAcessorios([]);
        if (!defeitosEncontrados) setDefeitos([]);
    }, [selectedProposal]);

    const handleSaveBankDetails = () => {
        if (!selectedProposal) return;
        console.log(selectedProposal?.bank_token,'selectedProposal?.bank_token')
        dispatch(
          updateBankData({
            token: selectedProposal?.bank_token,
            bank_data: selectedProposal?.bank_data,
          })
        );
        setShowEditModal(false);
      };

    return (
        <Container>
            <h2 className='text-center mb-4 titulo-modal'>Pedido de Vendas</h2>
            {successMessage && (
                <Alert className="text-center" variant="success">
                    {successMessage}
                    <Button className="m-3" variant="close" onClick={() => dispatch(clearMessages())}></Button>
                </Alert>
            )}
            {error && (
                <Alert className="text-center" variant="danger">
                    {error}
                    <Button className="m-3" variant="close" onClick={() => dispatch(clearMessages())}></Button>
                </Alert>
            )}
            <div className='d-flex justify-content-center'>
                <PaginationComponent
                    currentPage={pagination.currentPage}
                    lastPage={pagination.lastPage}
                    onPageChange={handlePageChange}
                />
            </div>
            <div className={`loading ${loading ? 'loading-active' : ''}`}>
                <Loader loading={loading} />
                <h5 style={{ color: '#333', fontWeight: '700' }}>{proposals[0]?.user?.name}</h5>
                <Table striped bordered hover responsive className='text-center mt-4'>
                    <thead>
                        <tr>
                            <th>N° Pedido</th>
                            <th>Data</th>
                            <th>Valor da Proposta</th>
                            <th>Status</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="4">Carregando...</td>
                            </tr>
                        ) : proposals.length > 0 ? (
                            proposals.map((proposal) => (
                                <tr key={proposal.id}>
                                    <td>{proposal.id}</td>
                                    <td>{formatDateBR(proposal.created_at)}</td>
                                    <td>{formatPriceBR(proposal?.proposal_value)}</td>
                                    <td>{getTextoTabela(proposal.status)}</td>
                                    <td>
                                        <Button
                                            variant="info"
                                            size="sm"
                                            className="me-2"
                                            onClick={() => handleViewDetails(proposal)}
                                        >
                                            Visualizar
                                        </Button>
                                        {proposal.bank_editable ? (
                                            <Button
                                                variant="warning"
                                                size="sm"
                                                onClick={() => handleEdit(proposal)}
                                            >
                                                Editar
                                            </Button>
                                        ) : (
                                            <Button
                                                variant="btn btn-secondary"
                                                size="sm"
                                                style={{ opacity: '0.5', cursor: 'not-allowed' }}
                                                disabled
                                            >
                                                Editar
                                            </Button>
                                        )}

                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="4">Nenhuma proposta encontrada.</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <Modal className="modal-custom" show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'> Dados da Proposta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="summary-container">
                        <div className="summary-content-wrapper">
                            {/* Coluna da listagem de atributos */}
                            <div className="info-modelo">
                                <h4>
                                    <span className="model-name">{selectedProposal?.modelo} {capacidade} {cor} {conexao}</span>
                                </h4>
                                <p >
                                    {formatPriceBR(selectedProposal?.proposal_value)}
                                </p>
                            </div>
                            {acessorios?.length > 0 && (
                                <div className="accessories-container">
                                    <h5>Acessórios</h5>
                                    <div className="tags-list">
                                        {acessorios?.map((item, index) => (
                                            <span key={index} className="tag">
                                                {item?.value}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {defeitos?.length > 0 ? (
                                <div className="accessories-container">
                                    <h5>Defeitos</h5>
                                    <div className="tags-list">
                                        {defeitos.map((item, index) => (
                                            <span key={index} className="tag">
                                                {item?.value}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            ) : null}
                            <div className="accessories-container">
                                <h5>Operação</h5>
                                <div className="tags-list">
                                    <span className="tag">
                                        {operacao}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className='box-option'>
                        <h4 className='text-center pb-3' style={{ fontWeight: 700 }}>Informações do Aparelho</h4>
                        <ul>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Marca:</strong> {selectedProposal?.marca}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Tipo:</strong> {selectedProposal?.tipo}</span></p></li>
                            {/* <li><p><i className="fa-solid fa-check"></i><span className="option-value">Modelo: {selectedProposal?.modelo}</span></p></li>*/}
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>IMEI:</strong> {selectedProposal?.imei}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Número de Série:</strong> {selectedProposal?.serial_number}</span></p></li>
                        </ul>
                    </div>
                    <div className='box-option'>
                        <h4 className='text-center pb-3' style={{ fontWeight: 700 }} >Informações Pessoais</h4>
                        <ul>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Nome:</strong> {selectedProposal?.user.name}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>RG:</strong> {selectedProposal?.user?.rg}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>CPF:</strong> {selectedProposal?.user?.cpf}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Telefone:</strong> {selectedProposal?.user?.telefone}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Email:</strong> {selectedProposal?.user.email}</span></p></li>
                            <li><p><i className="fa-solid fa-check"></i><span className="option-value"><strong>Endereço:</strong> {selectedProposal?.user?.address.address} - N° {selectedProposal?.user?.address.number} {selectedProposal?.user?.address.complement} - {selectedProposal?.user?.address.neighborhood} - {selectedProposal?.user?.address.city} / {selectedProposal?.user?.address.state}</span></p></li>
                        </ul>
                    </div>
                    {selectedProposal?.bank_data && (
                        <div className='box-option'>
                            <h4 className='text-center pb-3' style={{ fontWeight: 700 }}>Dados Bancários</h4>
                            <ul>
                                <li>
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        <span className="option-value"><strong>Nome:</strong> {selectedProposal?.user.name}</span>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        <span className="option-value"><strong>Nome do Banco:</strong> {selectedProposal.bank_data.bank_name}</span>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        <span className="option-value"><strong>N° da agência:</strong> {selectedProposal.bank_data.agency_number}</span>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        <span className="option-value"><strong>N° da conta:</strong> {selectedProposal.bank_data.account_number}</span>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <i className="fa-solid fa-check"></i>
                                        <span className="option-value">
                                            <strong> CPF: </strong>{selectedProposal?.user?.cpf}
                                        </span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    )}
                    <div className='box-option'>
                        <h4 className='text-center' style={{ fontWeight: 700 }}>Status da Avaliação</h4>
                        <ul>
                            {(selectedProposal?.status <= 3) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Status:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  {getTextoTabela(selectedProposal?.status)}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {selectedProposal?.codigo != null &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Código para Envio:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i> {selectedProposal?.codigo}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }

                        </ul>
                        <ul>
                            {(selectedProposal?.status == 5) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Status:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  {getTextoTabela(selectedProposal?.status)}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {(selectedProposal?.status == 6) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Status:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  {getTextoTabela(selectedProposal?.status)}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {selectedProposal?.rejectionReason != null &&
                                (
                                    <div className="box-option">
                                        <h5><strong>Status Reprovado</strong></h5>
                                        <ul>
                                            <label><strong>Motivo:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>
                                                    <div
                                                        className="option-value"
                                                        dangerouslySetInnerHTML={{ __html: selectedProposal?.rejectionReason }}
                                                    />
                                                </p>
                                            </li>
                                            <label><strong>Novo Valor da Proposta:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  R$ {selectedProposal?.proposal_value_new}
                                                </p>
                                            </li>
                                            <label><strong>Custo Frete:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i> R$ {selectedProposal?.custo_frete}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {selectedProposal?.data_pagamento != null &&
                                (
                                    <div className="box-option">
                                        <h5><strong>Contraproposta</strong></h5>
                                        <ul>
                                            <label><strong>Data do Pagamento:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>
                                                    <p>{formatDateBR(selectedProposal?.data_pagamento)}</p>
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {(selectedProposal?.status == 9) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Status:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  {getTextoTabela(selectedProposal?.status)}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                        <ul>
                            {(selectedProposal?.codigo_dev != null) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Código para Devolução:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i> {selectedProposal?.codigo_dev}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>

                                )
                            }
                        </ul>
                        <ul>
                            {(selectedProposal?.status == 11) &&
                                (
                                    <div className="box-option">
                                        <ul>
                                            <label><strong>Status:</strong></label>
                                            <li>
                                                <p style={{ marginLeft: '15px' }}>
                                                    <i className="fa-solid fa-check"></i>  {getTextoTabela(selectedProposal?.status)}
                                                </p>
                                            </li>
                                        </ul>
                                    </div>
                                )
                            }
                        </ul>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showEditModal} onHide={handleModalClose} >
                <Modal.Header closeButton>
                    <Modal.Title className='w-100 text-center titulo-modal'>Editar Dados Bancários</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="bankName">
                            <Form.Label>Nome do Banco</Form.Label>
                            <Form.Control
                                type="text"
                                name="bank_name"
                                value={selectedProposal?.bank_data?.bank_name}
                                onChange={handleBankDetailChange}
                                required

                            />
                        </Form.Group>
                        <Form.Group controlId="agency" className="mt-2">
                            <Form.Label>Agência</Form.Label>
                            <Form.Control
                                type="text"
                                name="agency_number"
                                value={selectedProposal?.bank_data?.agency_number}
                                onChange={handleBankDetailChange}
                                required

                            />
                        </Form.Group>
                        <Form.Group controlId="account" className="mt-2">
                            <Form.Label>Conta</Form.Label>
                            <Form.Control
                                type="text"
                                name="account_number"
                                value={selectedProposal?.bank_data?.account_number}
                                onChange={handleBankDetailChange}
                                required
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                        Cancelar
                    </Button>
                    <Button variant="primary" onClick={handleSaveBankDetails}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container >
    );
};

export default Proposta;
